// Einzug.js
// Wie die Tabelle im Behelf: eine Spalte pro Station, eine Zeile pro Zug.
// Gebraucht von jeder Ansicht, die einen Funkverkehr zeigt; der Kopf mit den
// Stationsnamen steht in AblaufKopf.vue.
//
// Die sprechenden Rollen in der Reihenfolge ihres ersten Auftritts. Wer
// zuerst spricht, steht links. Jede Station bekommt eine gleich breite
// Spalte; ein Zug steht in der Spalte seiner Station.
//
//   const einzug = einzugFuer(uebung)
//   <div :style="einzug(zug)">

export function stationenVon(uebung) {
  return [...new Set(uebung.zuege.map(z => z.spricht))]
}

export function einzugFuer(uebung) {
  const sprecher = stationenVon(uebung)
  const breite = 100 / sprecher.length
  return (zug) => ({
    marginLeft: breite * sprecher.indexOf(zug.spricht) + '%',
    width: breite + '%',
    boxSizing: 'border-box'
  })
}
